<template>
    <div>
       <el-row type="flex" class="row-bg" justify="center">
           <el-col :span="24">
                <el-card class="box-card card">
                    <el-row class="title-box">
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark info-box">
                                <span class="title">灵活就业认证信息审核</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                        <div class="grid-content bg-purple-dark">
                            <el-form :label-position="labelPosition" label-width="148px">
                                    <el-form-item label="公司名称">
                                        <el-input v-model="companyName" readonly="readonly" class="inp text-bg define-inp" placeholder="请输入公司名称"></el-input>
                                    </el-form-item>
                                    
                                    <!-- <el-form-item label="经营范围">
                                        <el-input class="inp text-bg"
                                        type="textarea"
                                        :rows="10"
                                        placeholder=""
                                        v-model="textarea"
                                        show-word-limit
                                        >
                                        </el-input>
                                    </el-form-item> -->

                            <!-- 统一社会信用代码 -->
                                    <el-form-item :label="label" class="code">
                                        <el-input v-model="code" readonly="readonly" class="inp text-bg define-inp"></el-input>
                                    </el-form-item>
                            
                                     <el-form-item label="地址(营业执照地址)">
                                        <el-input v-model="address" readonly="readonly" class="inp text-bg define-inp"></el-input>
                                    </el-form-item>
                                    <el-form-item label="资质文件" style="">
                                        <el-col :span="20">
                                    
                                            <!-- <el-image :src="item" class="image" v-for="(item,index) in flexbelJobInfo.approveImgUrl" :key="index">
                                                <div slot="placeholder" class="image-slot">
                                                    加载中<span class="dot">...</span>
                                                </div>
                                            </el-image> -->
                                            <el-image 
                                                v-for="(item,index) in flexbelJobInfo.approveImgUrl" :key="index"
                                                class="image"
                                                :src="item" 
                                                :preview-src-list="srcList">
                                                 <div slot="placeholder" class="image-slot">
                                                    加载中<span class="dot">...</span>
                                                </div>
                                            </el-image>
                                            
                                            
                                        </el-col>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>
                    
                    <el-row type="flex" justify="center" class="btn-list" v-if="flexbelJobInfo.approveStatus==1">
                        <el-col :span="13" style="text-align:center;">
                            <el-button type="primary theme-btn" class="btn pass" @click.native="submitRemake(2,remake)">通过</el-button>
                            <el-button class="btn refuse" @click.native="alertRemakeFn">拒绝</el-button>           
                        </el-col>
                    </el-row>
                </el-card>
           </el-col>
       </el-row>


    <!-- 审核理由对话框 -->
        <el-dialog
            :visible.sync="showRemake"
            width="30%"
            >
            <div>
                <el-input
                    type="textarea"
                    class="checkText"
                    :rows="10"
                    placeholder="请输入拒绝理由"
                    maxlength="99"
                    show-word-limit
                    v-model="remake">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showRemake = false">取 消</el-button>
                <el-button class="theme-btn" type="primary" @click.native="submitRemake(3,remake)">提 交</el-button>
            </span>
        </el-dialog>
       
    </div>
</template>
<script>

export default {
    data(){
        return {
            labelPosition: 'right',
            label:'统一社会信用代码\n或注册号',

            showRemake:false,
            remake:'',  // 审核理由	
            code:'',    // 统一社会信用代码或注册号
            companyName:'', // 公司名称
            address:'',  // 地址(营业执照地址)
            srcList:[],   // 存放所有图片
            flexbelJobInfo:[],   // 所有数据

            // src:'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        }
    },
    props:['item'],
    methods:{
        alertRemakeFn(){
            this.showRemake = true;
        },
        submitRemake(status,remake){    // 2 通过  3拒绝
            let id = this.item.id
            let that = this
            this.axiosPost(`/web/companyApprove/checkout`,
                {
                    id:id,
                    approveStatus:status,
                    remake:remake
                }
            ).then((res)=>{
                let status = res.code == 200 ? 'success' : 'error'
                this.$message({
                    showClose: true,
                    message: res.message,
                    type: status,
                    duration:1500
                });
             that.$emit('statusFun',true)
            })
        }
    },
    created(){
        let id = this.item.id
        this.axiosGet(`/web/companyApprove/findById/${id}`).then((res)=>{
            // console.log('灵活')
            // console.log(res)
            if(res.code==200){
                // console.log('灵活就业')
                // console.log(res)
                
                this.code = res.data.businessInformationVo.code    // 统一社会信用代码或注册号
                this.companyName = res.data.companyName // 公司名称
                this.address = res.data.businessInformationVo.address  // 地址(营业执照地址)
                this.flexbelJobInfo = res.data   // 所有数据
                this.srcList = res.data.approveImgUrl
            }
        })
    }
}
</script>
<style lang="less" scoped>
    .inp{
        width:80%;
    }
    .num{ 
        font-size: 48px;
        font-weight: 500;
        color: #197FFB;
        line-height: 74px;
        margin-right:10px;
    }
    .info-box{
        padding-left:50px;
    }
    .form{
        padding-left:78px;
    }
    .title-box{
        margin:20px 0;
        .title{     
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 30px;
            position:relative;
            bottom:5px;
        }
    }
    .chck{
        font-size: 14px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #333333;
        line-height: 30px;
    }
    .el-col-offset-8{
        margin-left:40.3333%
    }
    .btn_fb{
        margin-top:20px;
    }
    .image{
        width:30%;
        height: 170px;
        margin-right:3%;
    }
    .image:last-child{
        margin-right:0;
    }
    .btn{
        width: 40%;
        height:46px; 
        border-radius: 8px;    
        font-size: 18px;
        font-weight: 400;
    }
    .pass{
        margin-right:51px;
    }
    .refuse{
        color: #1A80FC;
        background: #EEF2FB;
    }
    // .btn-list{
    //     margin-top:230px;
    // }

    // .el-form-item__label{
    //     white-space:pre-line;
    //     text-align:left;
    // }

    // //如果是table的话就
    // .el-table .cell{
    //     white-space:pre-line;
    // }





    .row-bg{
        margin-top:20px;
    }

</style>